import { render, staticRenderFns } from "./Atlas.vue?vue&type=template&id=abd79890&scoped=true"
import script from "./Atlas.vue?vue&type=script&lang=js"
export * from "./Atlas.vue?vue&type=script&lang=js"
import style0 from "./Atlas.vue?vue&type=style&index=0&id=abd79890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd79890",
  null
  
)

export default component.exports